import Vue from 'vue'
import Router from 'vue-router'
/* Layout */
import Layout from '@/layout'

/* Router Modules */
import asyncRouters from './modules'
import SystemMgrRouter from '@/router/modules/systemMgr' // 系统管理
import ViewRouter from '@/router/modules/viewRouter'
import MobileRouter from '@/router/modules/mobileRouter'
import TestRouter from '@/router/modules/testRouter'
import ExternalAccessRouter from '@/router/modules/externalAccessRouter'

Vue.use(Router)

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-views
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    meta: { title: '登录', noCache: true },
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/newDashboard'),
        name: 'Dashboard',
        meta: { title: '工作台', icon: 'dashboard_new', affix: true }
      }
    ]
  },
  {
    path: '/profile',
    component: Layout,
    redirect: '/profile/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/profile/index'),
        name: 'Profile',
        meta: { title: '个人中心', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/reset-password',
    component: Layout,
    redirect: '/reset-password/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/resetPassword/index'),
        name: 'reset-password',
        meta: { title: '修改密码', icon: 'user', noCache: true }
      }
    ]
  },
  {
    path: '/loading',
    component: () => import('@/layout/components/loading'),
    hidden: true
  },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    meta: { title: '404', noCache: true },
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    meta: { title: '401', noCache: true },
    hidden: true
  },
  {
    path: '/api_config',
    component: () => import('@/views/api-config/index'),
    meta: { title: 'api配置', noCache: true },
    hidden: true
  },
  {
    path: '/logo_config',
    component: () => import('@/views/logo-config/index'),
    meta: { title: 'logo配置', noCache: true },
    hidden: true
  },
  {
    path: '/test',
    component: () => import('@/views/test/mindAr/testMindAr'),
    name: 'test'
  },
  {
    path: '/arTest',
    component: () => import('@/views/test/mindAr/testMindAr'),
    name: 'arTest'
  },
  {
    path: '/testArticle',
    component: Layout,
    redirect: '/testArticle/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/test/richText/scroll'),
        name: 'testArticleIndex',
        meta: { title: '测试文章' }
      }
    ]
  },
  ViewRouter,
  ...ExternalAccessRouter,
  ...MobileRouter,
  ...TestRouter
]

export const lastRouters = [
  SystemMgrRouter
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on userInfo roles
 */
export const asyncRoutes = [
  /** when your routing map is too long, you can split it into small modules **/
  ...asyncRouters,
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
